module.exports = __webpack_public_path__ + "static/media/KMH_4990.055fea71.jpg";